import { ColDef, ColGroupDef } from '@ag-grid-community/core';

import { genericGetAttributeColumns } from '@features/budget-attributes/attribute-columns';

import { getCellClassForGroups } from '@shared/utils/ag-cell-class-for-groups';
import { Utils } from '@shared/utils/utils';

import { getCostCategoryColumn } from './ima-cost-category-column';
import {
  defaultHeaderClass,
  defaultMinWidth,
  InMonthAdjustmentGridConfigContext,
} from './ima-grid-config-context';

export const imaAttributesColumnGroup = (ctx: InMonthAdjustmentGridConfigContext): ColGroupDef => {
  const { attributeConfig } = ctx;
  const isPrimarySelected = !!attributeConfig.primaryAttribute?.attribute_name;

  const otherAttributes = genericGetAttributeColumns({
    attributeConfig,
    colDefOverrides: {
      cellClass: getCellClassForGroups,
      columnGroupShow: 'open',
      headerClass: defaultHeaderClass,
      minWidth: defaultMinWidth,
    },
    onlyPivot: null,
    showHeaderTooltip: true,
    widthConfig: {
      maxWidth: 320,
      minWidth: defaultMinWidth,
      offset: 60,
    },
  });

  const children: ColDef[] = [];

  if (isPrimarySelected) {
    children.push(getCostCategoryColumn(ctx));
  }

  children.push(...otherAttributes);
  children.sort((a, b) => Utils.localeAlphaNumSort(a.headerName || '', b.headerName || ''));

  return {
    children,
    groupId: 'attributes',
    headerClass: ['text-center', 'header-marker', 'green-marker'],
    headerName: 'Attributes',
    suppressStickyLabel: true,
  };
};
